// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ═══════════════════════════════════════════════════════════
   AdminCourses.css
   Design tokens from AdminLayout.css (--admin-*)
═══════════════════════════════════════════════════════════ */

/* ── Stat bar (course list top) ── */
.acr__stat-bar {
  display: grid;
  grid-template-columns: repeat(3, auto) 1fr;
  gap: 1rem;
  margin-bottom: 1.25rem;
  align-items: stretch;
}
.acr__stat-card {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding: 1rem 1.25rem;
}
.acr__stat-card--cta {
  padding: 0.75rem 1rem;
  justify-content: center;
}
.acr__stat-label {
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--admin-muted);
  margin: 0;
}
.acr__stat-value {
  font-family: var(--font-serif);
  font-size: 1.75rem;
  font-weight: 700;
  color: var(--admin-text);
  margin: 0;
  line-height: 1.1;
}
.acr__stat-value--green {
  color: var(--admin-green);
}
.acr__stat-value--amber {
  color: var(--admin-amber);
}

/* ── New course row ── */
.acr__new-course-row {
  display: flex;
  gap: 0.65rem;
  align-items: center;
  width: 100%;
}

/* ── Loading ── */
.acr__loading-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
}
.acr__spinner {
  width: 2rem;
  height: 2rem;
  border: 2px solid rgba(var(--admin-rust-rgb), 0.2);
  border-top-color: var(--admin-rust);
  border-radius: 50%;
  animation: acr-spin 0.7s linear infinite;
}
@keyframes acr-spin {
  to {
    transform: rotate(360deg);
  }
}

.acr__editor-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 300px;
}

/* ── Empty state ── */
.acr__empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  text-align: center;
}
.acr__empty-icon {
  font-size: 2.75rem;
  color: var(--admin-muted);
  margin-bottom: 0.85rem;
}
.acr__empty-title {
  font-family: var(--font-serif);
  font-size: 1.2rem;
  color: var(--admin-text);
  margin: 0 0 0.4rem;
}
.acr__empty-sub {
  font-size: 0.84rem;
  color: var(--admin-muted);
  margin: 0;
}

/* ── Course list ── */
.acr__course-list {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}

.acr__course-card {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  padding: 1.1rem 1.25rem;
  transition: box-shadow 0.15s;
}
.acr__course-card:hover {
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.acr__course-thumb {
  width: 80px;
  height: 56px;
  flex-shrink: 0;
  border-radius: 6px;
  overflow: hidden;
  background: var(--admin-border);
}
.acr__course-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.acr__course-body {
  flex: 1 1;
  min-width: 0;
}
.acr__course-top {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  margin-bottom: 0.3rem;
  flex-wrap: wrap;
}
.acr__course-title {
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--admin-text);
  margin: 0;
}
.acr__course-desc {
  font-size: 0.8rem;
  color: var(--admin-muted);
  margin: 0 0 0.4rem;
  line-height: 1.5;
}
.acr__course-meta {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.75rem;
  color: var(--admin-muted);
}
.acr__stat-dot {
  opacity: 0.4;
}

.acr__course-actions {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  flex-shrink: 0;
}
.acr__delete-btn {
  color: var(--admin-red) !important;
  border-color: rgba(220, 38, 38, 0.3) !important;
}
.acr__delete-btn:hover {
  background: rgba(220, 38, 38, 0.07) !important;
}

/* ── Badge ── */
.acr__badge {
  display: inline-flex;
  align-items: center;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  padding: 0.18rem 0.55rem;
  border-radius: 99px;
  flex-shrink: 0;
}

/* ── Form fields ── */
.acr__form-field {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}
.acr__form-label {
  font-size: 0.78rem;
  font-weight: 700;
  color: var(--admin-text);
}
.acr__req {
  color: var(--admin-rust);
}
.acr__form-hint {
  font-size: 0.7rem;
  color: var(--admin-muted);
  margin: 0.15rem 0 0;
}
.acr__form-input {
  padding: 0.6rem 0.8rem;
  border: 1px solid var(--admin-border);
  border-radius: 7px;
  background: #fff;
  font-size: 0.85rem;
  color: var(--admin-text);
  outline: none;
  font-family: inherit;
  width: 100%;
  box-sizing: border-box;
  transition: border-color 0.15s;
}
.acr__form-input:focus {
  border-color: var(--admin-rust);
  box-shadow: 0 0 0 2px rgba(var(--admin-rust-rgb), 0.09);
}
.acr__form-textarea {
  resize: vertical;
  min-height: 80px;
}
.acr__form-select {
  appearance: none;
  cursor: pointer;
}
.acr__form-row {
  display: flex;
  gap: 1rem;
  align-items: flex-end;
}
.acr__form-field--toggle {
  flex-direction: row;
  align-items: center;
  gap: 0.6rem;
}

/* Toggle */
.acr__toggle {
  position: relative;
  width: 2.5rem;
  height: 1.4rem;
  border-radius: 99px;
  background: var(--admin-border);
  border: none;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.2s;
  padding: 0;
}
.acr__toggle--on {
  background: var(--admin-rust);
}
.acr__toggle-thumb {
  position: absolute;
  top: 3px;
  left: 3px;
  width: 1.05rem;
  height: 1.05rem;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  transition: transform 0.2s;
  display: block;
}
.acr__toggle--on .acr__toggle-thumb {
  transform: translateX(1.1rem);
}
.acr__toggle-label {
  font-size: 0.78rem;
  color: var(--admin-muted);
}

/* ── Inline editable ── */
.acr__editable {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  cursor: pointer;
  border-radius: 5px;
  padding: 0.1rem 0.35rem;
  transition: background 0.12s;
}
.acr__editable:hover {
  background: rgba(var(--admin-rust-rgb), 0.06);
}
.acr__editable-icon {
  font-size: 0.75rem;
  opacity: 0;
  transition: opacity 0.12s;
  flex-shrink: 0;
  color: var(--admin-rust);
}
.acr__editable:hover .acr__editable-icon {
  opacity: 1;
}
.acr__editable-ph {
  color: var(--admin-muted);
  font-style: italic;
}

.acr__editable--editing {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
}
.acr__inline-input {
  padding: 0.35rem 0.6rem;
  border: 1px solid var(--admin-rust);
  border-radius: 5px;
  font-size: inherit;
  font-family: inherit;
  color: var(--admin-text);
  outline: none;
  box-shadow: 0 0 0 2px rgba(var(--admin-rust-rgb), 0.12);
}
.acr__inline-textarea {
  resize: none;
  font-size: 0.84rem;
  width: 100%;
}
.acr__inline-ok,
.acr__inline-no {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.6rem;
  height: 1.6rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.8rem;
  flex-shrink: 0;
}
.acr__inline-ok {
  background: rgba(22, 163, 74, 0.1);
  color: var(--admin-green);
}
.acr__inline-ok:hover {
  background: rgba(22, 163, 74, 0.2);
}
.acr__inline-no {
  background: rgba(220, 38, 38, 0.08);
  color: var(--admin-red);
}
.acr__inline-no:hover {
  background: rgba(220, 38, 38, 0.15);
}

/* ── Icon button ── */
.acr__icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.9rem;
  height: 1.9rem;
  border: none;
  border-radius: 6px;
  background: none;
  cursor: pointer;
  font-size: 0.9rem;
  color: var(--admin-muted);
  transition:
    background 0.12s,
    color 0.12s;
  flex-shrink: 0;
}
.acr__icon-btn:hover {
  background: var(--admin-border);
  color: var(--admin-text);
}
.acr__icon-btn:disabled {
  opacity: 0.3;
  cursor: default;
}
.acr__icon-btn--danger:hover {
  background: rgba(220, 38, 38, 0.1);
  color: var(--admin-red);
}

/* ════════════════════════════════════════════════════════
   COURSE EDITOR
════════════════════════════════════════════════════════ */
.acr__editor {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.25rem;
  min-height: 60vh;
}
.acr__editor--with-panel {
  grid-template-columns: 1fr 0.8fr;
  align-items: start;
}

.acr__editor-main {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

/* Editor header */
.acr__editor-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.75rem;
}
.acr__back-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 0.82rem;
  font-weight: 700;
  color: var(--admin-muted);
  padding: 0;
  transition: color 0.15s;
}
.acr__back-btn:hover {
  color: var(--admin-rust);
}
.acr__editor-head-right {
  display: flex;
  align-items: center;
  gap: 0.65rem;
}
.acr__settings-btn {
  gap: 0.4rem !important;
}

/* Course title in editor */
.acr__editor-title-wrap {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  background: #fff;
  border: 1px solid var(--admin-border);
  border-radius: 10px;
  padding: 1rem 1.25rem;
}
.acr__editor-title-icon {
  font-size: 1.4rem;
  color: var(--admin-rust);
  flex-shrink: 0;
}
.acr__course-title-editable {
  font-size: 1.2rem;
  font-weight: 700;
}
.acr__chapter-title-editable {
  font-size: 0.92rem;
  font-weight: 600;
  flex: 1 1;
  min-width: 0;
}

/* Stats under title */
.acr__editor-stats {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.78rem;
  color: var(--admin-muted);
  padding: 0 0.25rem;
}

/* Settings panel */
.acr__settings-panel {
  padding: 1.25rem;
}
.acr__settings-title {
  font-size: 0.88rem;
  font-weight: 700;
  color: var(--admin-text);
  margin: 0 0 1rem;
}
.acr__settings-grid {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}
.acr__settings-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.85rem;
}
.acr__settings-footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-top: 1rem;
}

/* ── Chapters ── */
.acr__chapters {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
.acr__empty-chapters {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 3rem 1rem;
  text-align: center;
  background: #fff;
  border: 2px dashed var(--admin-border);
  border-radius: 10px;
}

/* Chapter row */
.acr__chapter {
  background: #fff;
  border: 1px solid var(--admin-border);
  border-radius: 10px;
  overflow: hidden;
}

.acr__chapter-head {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.85rem 1rem;
  border-bottom: 1px solid transparent;
  background: var(--admin-surface);
  transition: border-color 0.15s;
}
.acr__chapter:has(.acr__lessons) .acr__chapter-head {
  border-bottom-color: var(--admin-border);
}

.acr__chapter-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 0.85rem;
  color: var(--admin-muted);
  flex-shrink: 0;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 4px;
  padding: 0;
  transition: background 0.12s;
}
.acr__chapter-toggle:hover {
  background: var(--admin-border);
}

.acr__chapter-num {
  font-size: 0.65rem;
  font-weight: 800;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--admin-rust);
  flex-shrink: 0;
  min-width: 2.5rem;
}

.acr__chapter-actions {
  display: flex;
  align-items: center;
  gap: 0.2rem;
  margin-left: auto;
  flex-shrink: 0;
}
.acr__chapter-count {
  font-size: 0.72rem;
  color: var(--admin-muted);
  margin-right: 0.35rem;
  white-space: nowrap;
}

/* Lessons inside a chapter */
.acr__lessons {
  display: flex;
  flex-direction: column;
}
.acr__lessons-empty {
  font-size: 0.78rem;
  color: var(--admin-muted);
  padding: 1rem;
  text-align: center;
}

.acr__lesson-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.65rem 1rem;
  border-bottom: 1px solid var(--admin-border);
  cursor: pointer;
  transition: background 0.12s;
}
.acr__lesson-row:last-of-type {
  border-bottom: none;
}
.acr__lesson-row:hover {
  background: var(--admin-bg);
}
.acr__lesson-row--active {
  background: rgba(var(--admin-rust-rgb), 0.04);
  border-left: 2px solid var(--admin-rust);
}

.acr__lesson-left {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.84rem;
  color: var(--admin-text);
  min-width: 0;
  flex: 1 1;
}
.acr__lesson-num {
  font-size: 0.65rem;
  font-weight: 800;
  color: var(--admin-muted);
  min-width: 1.2rem;
}
.acr__lesson-title {
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.acr__lesson-opt {
  font-size: 0.65rem;
  background: rgba(107, 98, 88, 0.1);
  color: var(--admin-muted);
  padding: 0.1rem 0.45rem;
  border-radius: 99px;
  flex-shrink: 0;
}
.acr__lesson-dur {
  font-size: 0.68rem;
  color: var(--admin-muted);
  flex-shrink: 0;
}
.acr__lesson-actions {
  display: flex;
  align-items: center;
  gap: 0.15rem;
  flex-shrink: 0;
}

/* Add lesson form */
.acr__add-lesson-form {
  padding: 0.85rem 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  background: var(--admin-bg);
  border-top: 1px solid var(--admin-border);
}
.acr__add-lesson-types {
  display: flex;
  gap: 0.4rem;
  flex-wrap: wrap;
}
.acr__add-type-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.3rem 0.65rem;
  border-radius: 6px;
  font-size: 0.74rem;
  font-weight: 600;
  border: 1.5px solid var(--admin-border);
  background: #fff;
  color: var(--admin-muted);
  cursor: pointer;
  transition: all 0.12s;
}
.acr__add-type-btn:hover {
  border-color: var(--admin-rust);
  color: var(--admin-rust);
}
.acr__add-type-btn--active {
  background: var(--admin-rust);
  border-color: var(--admin-rust);
  color: #fff;
}
.acr__add-lesson-row {
  display: flex;
  gap: 0.5rem;
}

.acr__add-lesson-btn,
.acr__add-chapter-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  width: 100%;
  padding: 0.7rem;
  background: none;
  border: 2px dashed var(--admin-border);
  border-radius: 0 0 9px 9px;
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--admin-muted);
  cursor: pointer;
  transition: all 0.15s;
}
.acr__add-lesson-btn:hover,
.acr__add-chapter-btn:hover {
  border-color: var(--admin-rust);
  color: var(--admin-rust);
  background: rgba(var(--admin-rust-rgb), 0.03);
}

.acr__add-chapter-btn {
  border-radius: 10px;
  margin-top: 0;
  padding: 1rem;
}

/* Add chapter form */
.acr__add-chapter-form {
  display: flex;
  gap: 0.65rem;
  align-items: center;
  padding: 0.85rem 1rem;
  background: #fff;
  border: 1px solid var(--admin-border);
  border-radius: 10px;
}

/* ════════════════════════════════════════════════════════
   LESSON EDITOR PANEL
════════════════════════════════════════════════════════ */
.acr__lesson-editor {
  background: #fff;
  border: 1px solid var(--admin-border);
  border-radius: 10px;
  overflow: hidden;
  position: sticky;
  top: calc(var(--admin-topbar-h) + 1rem);
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - var(--admin-topbar-h) - 3rem);
}

.acr__le-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.9rem 1.1rem;
  border-bottom: 1px solid var(--admin-border);
  background: var(--admin-surface);
  flex-shrink: 0;
}
.acr__le-head-left {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.acr__le-title {
  font-size: 0.88rem;
  font-weight: 700;
  color: var(--admin-text);
}

.acr__le-body {
  padding: 1.1rem;
  overflow-y: auto;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.acr__le-footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  padding: 0.85rem 1.1rem;
  border-top: 1px solid var(--admin-border);
  background: var(--admin-surface);
  flex-shrink: 0;
}

/* Type grid in lesson editor */
.acr__type-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 0.4rem;
}
.acr__type-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
  padding: 0.5rem 0.25rem;
  border-radius: 7px;
  border: 1.5px solid var(--admin-border);
  background: #fff;
  font-size: 0.68rem;
  font-weight: 600;
  color: var(--admin-muted);
  cursor: pointer;
  transition: all 0.12s;
  text-align: center;
}
.acr__type-icon {
  font-size: 1.1rem;
}
.acr__type-btn:hover {
  border-color: var(--admin-rust);
  color: var(--admin-rust);
}
.acr__type-btn--active {
  background: var(--admin-rust);
  border-color: var(--admin-rust);
  color: #fff;
}

/* ══ Responsive ═══════════════════════════════════════════ */
@media (max-width: 1199px) {
  .acr__editor--with-panel {
    grid-template-columns: 1fr;
  }
  .acr__lesson-editor {
    position: static;
    max-height: none;
  }
  .acr__type-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 767px) {
  .acr__stat-bar {
    grid-template-columns: 1fr 1fr;
  }
  .acr__stat-bar > :last-child {
    grid-column: 1 / -1;
  }
  .acr__course-card {
    flex-direction: column;
  }
  .acr__course-actions {
    width: 100%;
    justify-content: flex-end;
  }
  .acr__settings-row {
    grid-template-columns: 1fr;
  }
  .acr__type-grid {
    grid-template-columns: repeat(3, 1fr);
  }
  .acr__add-lesson-row {
    flex-wrap: wrap;
  }
  .acr__chapter-head {
    flex-wrap: wrap;
  }
}

/* ── Lesson editor loading state ── */
.acr__le-loading {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.6rem 0;
  font-size: 0.78rem;
  color: var(--admin-muted);
}

/* ═══════════════════════════════════════════════════════════
   QUIZ BUILDER
═══════════════════════════════════════════════════════════ */
.acr__quiz-builder {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}

/* ── Question card ── */
.acr__quiz-question {
  border: 1px solid var(--admin-border);
  border-radius: 9px;
  overflow: hidden;
  background: #fff;
}

.acr__quiz-q-head {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.65rem 0.85rem;
  background: var(--admin-surface);
  border-bottom: 1px solid var(--admin-border);
  flex-wrap: wrap;
}

.acr__quiz-q-num {
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--admin-rust);
  flex-shrink: 0;
  min-width: 1.8rem;
}

/* Multiple / Text toggle */
.acr__quiz-type-toggle {
  display: flex;
  border: 1.5px solid var(--admin-border);
  border-radius: 6px;
  overflow: hidden;
  flex-shrink: 0;
}
.acr__quiz-type-btn {
  padding: 0.28rem 0.65rem;
  font-size: 0.72rem;
  font-weight: 600;
  background: #fff;
  border: none;
  cursor: pointer;
  color: var(--admin-muted);
  transition: all 0.13s;
  border-right: 1.5px solid var(--admin-border);
}
.acr__quiz-type-btn:last-child {
  border-right: none;
}
.acr__quiz-type-btn:hover {
  background: var(--admin-bg);
}
.acr__quiz-type-btn--active {
  background: var(--admin-rust);
  color: #fff;
}

.acr__quiz-remove-q {
  margin-left: auto;
}

/* Question text input */
.acr__quiz-q-input {
  margin: 0.65rem 0.85rem 0.5rem;
  width: calc(100% - 1.7rem);
  font-weight: 600;
  font-size: 0.88rem;
}

/* ── Options (multiple choice) ── */
.acr__quiz-options {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  padding: 0.35rem 0.85rem 0.75rem;
}

.acr__quiz-option {
  display: flex;
  align-items: center;
  gap: 0.45rem;
}

/* Correct answer circle button */
.acr__quiz-correct-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.7rem;
  height: 1.7rem;
  border: none;
  border-radius: 50%;
  background: none;
  cursor: pointer;
  font-size: 1.05rem;
  color: var(--admin-muted);
  flex-shrink: 0;
  transition: color 0.12s;
  padding: 0;
}
.acr__quiz-correct-btn:hover {
  color: var(--admin-rust);
}
.acr__quiz-correct-btn--on {
  color: var(--admin-green);
}

/* Empty circle (since HiOutlineCircle doesn't exist in hi2) */
.acr__quiz-circle {
  display: inline-block;
  width: 1.1rem;
  height: 1.1rem;
  border: 2px solid currentColor;
  border-radius: 50%;
  flex-shrink: 0;
}

.acr__quiz-opt-letter {
  font-size: 0.7rem;
  font-weight: 800;
  color: var(--admin-muted);
  min-width: 1rem;
  text-align: center;
  flex-shrink: 0;
}

.acr__quiz-opt-input {
  flex: 1 1;
  font-size: 0.84rem;
  padding: 0.45rem 0.7rem;
  min-width: 0;
}

.acr__quiz-add-opt {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  margin-top: 0.2rem;
  padding: 0.3rem 0.6rem;
  background: none;
  border: 1.5px dashed var(--admin-border);
  border-radius: 6px;
  font-size: 0.74rem;
  font-weight: 600;
  color: var(--admin-muted);
  cursor: pointer;
  transition: all 0.13s;
  align-self: flex-start;
}
.acr__quiz-add-opt:hover {
  border-color: var(--admin-rust);
  color: var(--admin-rust);
}

.acr__quiz-hint {
  font-size: 0.71rem;
  color: var(--admin-amber);
  margin: 0.2rem 0 0;
  font-weight: 500;
}

/* ── Text answer hint ── */
.acr__quiz-text-hint {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  margin: 0.35rem 0.85rem 0.75rem;
  font-size: 0.77rem;
  color: var(--admin-muted);
  background: var(--admin-bg);
  border-radius: 6px;
  padding: 0.5rem 0.7rem;
}

/* ── Add question button ── */
.acr__quiz-add-q {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  width: 100%;
  padding: 0.75rem;
  background: none;
  border: 2px dashed var(--admin-border);
  border-radius: 9px;
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--admin-muted);
  cursor: pointer;
  transition: all 0.15s;
}
.acr__quiz-add-q:hover {
  border-color: var(--admin-rust);
  color: var(--admin-rust);
  background: rgba(var(--admin-rust-rgb), 0.03);
}

/* ── Tag multi-select grid ── */
.acr__tag-grid { display:flex; flex-wrap:wrap; gap:0.4rem; }
.acr__tag-btn {
  padding:0.3rem 0.75rem; border-radius:99px;
  border:1.5px solid var(--admin-border); background:#fff;
  font-size:0.74rem; font-weight:600; color:var(--admin-muted);
  cursor:pointer; transition:all 0.13s;
}
.acr__tag-btn:hover { border-color:var(--admin-rust); color:var(--admin-rust); }
.acr__tag-btn--active { background:var(--admin-rust); border-color:var(--admin-rust); color:#fff; }
.acr__tag-btn--stage.acr__tag-btn--active { background:#1e2a1e; border-color:#1e2a1e; }

/* Who gets it (shared course library) */
.acr__rules { margin-bottom: 1rem; }
.acr__share { display: flex; gap: 0.6rem; align-items: flex-start; margin-top: 0.25rem; cursor: pointer; }
.acr__share input { margin-top: 0.2rem; accent-color: var(--admin-rust); width: 1rem; height: 1rem; }
.acr__share b { display: block; font-size: 0.84rem; color: var(--admin-text); }
.acr__share em { display: block; font-style: normal; font-size: 0.78rem; color: var(--admin-muted); line-height: 1.45; max-width: 60ch; }
`, "",{"version":3,"sources":["webpack://./src/admin/AdminCourses.css"],"names":[],"mappings":"AAAA;;;6DAG6D;;AAE7D,qCAAqC;AACrC;EACE,aAAa;EACb,0CAA0C;EAC1C,SAAS;EACT,sBAAsB;EACtB,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;EACzB,SAAS;AACX;AACA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kDAAkD;EAClD,mCAAmC;EACnC,kBAAkB;EAClB,wCAAwC;AAC1C;AACA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,uBAAuB;EACvB,4BAA4B;AAC9B;AACA;EACE,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;AACjC;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,kCAAkC;EAClC,+CAA+C;AACjD;AACA;EACE,8CAA8C;AAChD;;AAEA,gBAAgB;AAChB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;EACxB,aAAa;EACb,oBAAoB;EACpB,WAAW;EACX,sBAAsB;EACtB,8BAA8B;AAChC;AACA;EACE,+BAA+B;EAC/B,uDAAuD;AACzD;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,SAAS;EACT,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;AACb;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,+BAA+B;EAC/B,YAAY;EACZ,eAAe;EACf,cAAc;EACd,2BAA2B;EAC3B,UAAU;AACZ;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;EACxC,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,0BAA0B;AAC1B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,uBAAuB;EACvB,4BAA4B;AAC9B;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,yBAAyB;EACzB,cAAc;EACd,wBAAwB;AAC1B;AACA;EACE,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,uBAAuB;EACvB,mCAAmC;EACnC,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,wBAAwB;EACxB,aAAa;EACb,uDAAuD;AACzD;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;AACA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,kCAAkC;EAClC,yBAAyB;AAC3B;AACA;EACE,kCAAkC;AACpC;AACA;EACE,mCAAmC;EACnC,uBAAuB;AACzB;AACA;EACE,mCAAmC;AACrC;;AAEA,sBAAsB;AACtB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB;;eAEa;EACb,cAAc;AAChB;AACA;EACE,+BAA+B;EAC/B,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;;0DAE0D;AAC1D;EACE,aAAa;EACb,0BAA0B;EAC1B,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,UAAU;EACV,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,sBAAsB;AACxB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,qCAAqC;EACrC,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAO;EACP,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;AACd;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,oCAAoC;EACpC,gCAAgC;EAChC,8BAA8B;AAChC;AACA;EACE,wCAAwC;AAC1C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,4BAA4B;AAC9B;AACA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,4CAA4C;EAC5C,eAAe;EACf,4BAA4B;AAC9B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,6CAA6C;EAC7C,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,YAAY;EACZ,SAAO;AACT;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,2BAA2B;EAC3B,yCAAyC;AAC3C;AACA;EACE,aAAa;EACb,WAAW;EACX,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,uCAAuC;EACvC,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,+BAA+B;EAC/B,wBAAwB;AAC1B;AACA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,WAAW;AACb;AACA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,sCAAsC;EACtC,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,qBAAqB;AACvB;AACA;;EAEE,+BAA+B;EAC/B,wBAAwB;EACxB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,aAAa;AACf;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;;0DAE0D;AAC1D;EACE,gBAAgB;EAChB,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,uCAAuC;EACvC,aAAa;EACb,sBAAsB;EACtB,sDAAsD;AACxD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,4CAA4C;EAC5C,gCAAgC;EAChC,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,uBAAuB;EACvB,yCAAyC;EACzC,gCAAgC;EAChC,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,uCAAuC;EACvC,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,+BAA+B;EAC/B,wBAAwB;AAC1B;AACA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,WAAW;AACb;;AAEA,8DAA8D;AAC9D;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,8BAA8B;EAChC;EACA;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,qCAAqC;EACvC;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;;6DAE6D;AAC7D;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA,wBAAwB;AACxB;EACE,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,gCAAgC;EAChC,4CAA4C;EAC5C,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,cAAc;EACd,iBAAiB;AACnB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,uCAAuC;EACvC,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,6CAA6C;AAC/C;AACA;EACE,kBAAkB;AACpB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA,wBAAwB;AACxB;EACE,8BAA8B;EAC9B,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA,iCAAiC;AACjC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,uBAAuB;EACvB,UAAU;AACZ;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;;AAEA,8DAA8D;AAC9D;EACE,qBAAqB;EACrB,aAAa;EACb,cAAc;EACd,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,wCAAwC;EACxC,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;EAClB,yBAAyB;EACzB,2BAA2B;EAC3B,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,sCAAsC;EACtC,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,+BAA+B;EAC/B,wBAAwB;EACxB,6CAA6C;AAC/C;;AAEA,gCAAgC;AAChC,iBAAiB,YAAY,EAAE,cAAc,EAAE,UAAU,EAAE;AAC3D;EACE,sBAAsB,EAAE,kBAAkB;EAC1C,sCAAsC,EAAE,eAAe;EACvD,iBAAiB,EAAE,eAAe,EAAE,wBAAwB;EAC5D,cAAc,EAAE,oBAAoB;AACtC;AACA,sBAAsB,8BAA8B,EAAE,uBAAuB,EAAE;AAC/E,wBAAwB,4BAA4B,EAAE,8BAA8B,EAAE,UAAU,EAAE;AAClG,4CAA4C,kBAAkB,EAAE,oBAAoB,EAAE;;AAEtF,wCAAwC;AACxC,cAAc,mBAAmB,EAAE;AACnC,cAAc,aAAa,EAAE,WAAW,EAAE,uBAAuB,EAAE,mBAAmB,EAAE,eAAe,EAAE;AACzG,oBAAoB,kBAAkB,EAAE,+BAA+B,EAAE,WAAW,EAAE,YAAY,EAAE;AACpG,gBAAgB,cAAc,EAAE,kBAAkB,EAAE,wBAAwB,EAAE;AAC9E,iBAAiB,cAAc,EAAE,kBAAkB,EAAE,kBAAkB,EAAE,yBAAyB,EAAE,iBAAiB,EAAE,eAAe,EAAE","sourcesContent":["/* ═══════════════════════════════════════════════════════════\n   AdminCourses.css\n   Design tokens from AdminLayout.css (--admin-*)\n═══════════════════════════════════════════════════════════ */\n\n/* ── Stat bar (course list top) ── */\n.acr__stat-bar {\n  display: grid;\n  grid-template-columns: repeat(3, auto) 1fr;\n  gap: 1rem;\n  margin-bottom: 1.25rem;\n  align-items: stretch;\n}\n.acr__stat-card {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  padding: 1rem 1.25rem;\n}\n.acr__stat-card--cta {\n  padding: 0.75rem 1rem;\n  justify-content: center;\n}\n.acr__stat-label {\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: var(--admin-muted);\n  margin: 0;\n}\n.acr__stat-value {\n  font-family: var(--font-serif);\n  font-size: 1.75rem;\n  font-weight: 700;\n  color: var(--admin-text);\n  margin: 0;\n  line-height: 1.1;\n}\n.acr__stat-value--green {\n  color: var(--admin-green);\n}\n.acr__stat-value--amber {\n  color: var(--admin-amber);\n}\n\n/* ── New course row ── */\n.acr__new-course-row {\n  display: flex;\n  gap: 0.65rem;\n  align-items: center;\n  width: 100%;\n}\n\n/* ── Loading ── */\n.acr__loading-wrap {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 200px;\n}\n.acr__spinner {\n  width: 2rem;\n  height: 2rem;\n  border: 2px solid rgba(var(--admin-rust-rgb), 0.2);\n  border-top-color: var(--admin-rust);\n  border-radius: 50%;\n  animation: acr-spin 0.7s linear infinite;\n}\n@keyframes acr-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.acr__editor-loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 300px;\n}\n\n/* ── Empty state ── */\n.acr__empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 4rem 2rem;\n  text-align: center;\n}\n.acr__empty-icon {\n  font-size: 2.75rem;\n  color: var(--admin-muted);\n  margin-bottom: 0.85rem;\n}\n.acr__empty-title {\n  font-family: var(--font-serif);\n  font-size: 1.2rem;\n  color: var(--admin-text);\n  margin: 0 0 0.4rem;\n}\n.acr__empty-sub {\n  font-size: 0.84rem;\n  color: var(--admin-muted);\n  margin: 0;\n}\n\n/* ── Course list ── */\n.acr__course-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.85rem;\n}\n\n.acr__course-card {\n  display: flex;\n  align-items: flex-start;\n  gap: 1rem;\n  padding: 1.1rem 1.25rem;\n  transition: box-shadow 0.15s;\n}\n.acr__course-card:hover {\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);\n}\n\n.acr__course-thumb {\n  width: 80px;\n  height: 56px;\n  flex-shrink: 0;\n  border-radius: 6px;\n  overflow: hidden;\n  background: var(--admin-border);\n}\n.acr__course-thumb img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.acr__course-body {\n  flex: 1;\n  min-width: 0;\n}\n.acr__course-top {\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n  margin-bottom: 0.3rem;\n  flex-wrap: wrap;\n}\n.acr__course-title {\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: var(--admin-text);\n  margin: 0;\n}\n.acr__course-desc {\n  font-size: 0.8rem;\n  color: var(--admin-muted);\n  margin: 0 0 0.4rem;\n  line-height: 1.5;\n}\n.acr__course-meta {\n  display: flex;\n  align-items: center;\n  gap: 0.35rem;\n  font-size: 0.75rem;\n  color: var(--admin-muted);\n}\n.acr__stat-dot {\n  opacity: 0.4;\n}\n\n.acr__course-actions {\n  display: flex;\n  gap: 0.5rem;\n  align-items: center;\n  flex-shrink: 0;\n}\n.acr__delete-btn {\n  color: var(--admin-red) !important;\n  border-color: rgba(220, 38, 38, 0.3) !important;\n}\n.acr__delete-btn:hover {\n  background: rgba(220, 38, 38, 0.07) !important;\n}\n\n/* ── Badge ── */\n.acr__badge {\n  display: inline-flex;\n  align-items: center;\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  padding: 0.18rem 0.55rem;\n  border-radius: 99px;\n  flex-shrink: 0;\n}\n\n/* ── Form fields ── */\n.acr__form-field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n}\n.acr__form-label {\n  font-size: 0.78rem;\n  font-weight: 700;\n  color: var(--admin-text);\n}\n.acr__req {\n  color: var(--admin-rust);\n}\n.acr__form-hint {\n  font-size: 0.7rem;\n  color: var(--admin-muted);\n  margin: 0.15rem 0 0;\n}\n.acr__form-input {\n  padding: 0.6rem 0.8rem;\n  border: 1px solid var(--admin-border);\n  border-radius: 7px;\n  background: #fff;\n  font-size: 0.85rem;\n  color: var(--admin-text);\n  outline: none;\n  font-family: inherit;\n  width: 100%;\n  box-sizing: border-box;\n  transition: border-color 0.15s;\n}\n.acr__form-input:focus {\n  border-color: var(--admin-rust);\n  box-shadow: 0 0 0 2px rgba(var(--admin-rust-rgb), 0.09);\n}\n.acr__form-textarea {\n  resize: vertical;\n  min-height: 80px;\n}\n.acr__form-select {\n  appearance: none;\n  cursor: pointer;\n}\n.acr__form-row {\n  display: flex;\n  gap: 1rem;\n  align-items: flex-end;\n}\n.acr__form-field--toggle {\n  flex-direction: row;\n  align-items: center;\n  gap: 0.6rem;\n}\n\n/* Toggle */\n.acr__toggle {\n  position: relative;\n  width: 2.5rem;\n  height: 1.4rem;\n  border-radius: 99px;\n  background: var(--admin-border);\n  border: none;\n  cursor: pointer;\n  flex-shrink: 0;\n  transition: background 0.2s;\n  padding: 0;\n}\n.acr__toggle--on {\n  background: var(--admin-rust);\n}\n.acr__toggle-thumb {\n  position: absolute;\n  top: 3px;\n  left: 3px;\n  width: 1.05rem;\n  height: 1.05rem;\n  border-radius: 50%;\n  background: #fff;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n  transition: transform 0.2s;\n  display: block;\n}\n.acr__toggle--on .acr__toggle-thumb {\n  transform: translateX(1.1rem);\n}\n.acr__toggle-label {\n  font-size: 0.78rem;\n  color: var(--admin-muted);\n}\n\n/* ── Inline editable ── */\n.acr__editable {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  cursor: pointer;\n  border-radius: 5px;\n  padding: 0.1rem 0.35rem;\n  transition: background 0.12s;\n}\n.acr__editable:hover {\n  background: rgba(var(--admin-rust-rgb), 0.06);\n}\n.acr__editable-icon {\n  font-size: 0.75rem;\n  opacity: 0;\n  transition: opacity 0.12s;\n  flex-shrink: 0;\n  color: var(--admin-rust);\n}\n.acr__editable:hover .acr__editable-icon {\n  opacity: 1;\n}\n.acr__editable-ph {\n  color: var(--admin-muted);\n  font-style: italic;\n}\n\n.acr__editable--editing {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n}\n.acr__inline-input {\n  padding: 0.35rem 0.6rem;\n  border: 1px solid var(--admin-rust);\n  border-radius: 5px;\n  font-size: inherit;\n  font-family: inherit;\n  color: var(--admin-text);\n  outline: none;\n  box-shadow: 0 0 0 2px rgba(var(--admin-rust-rgb), 0.12);\n}\n.acr__inline-textarea {\n  resize: none;\n  font-size: 0.84rem;\n  width: 100%;\n}\n.acr__inline-ok,\n.acr__inline-no {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.6rem;\n  height: 1.6rem;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.8rem;\n  flex-shrink: 0;\n}\n.acr__inline-ok {\n  background: rgba(22, 163, 74, 0.1);\n  color: var(--admin-green);\n}\n.acr__inline-ok:hover {\n  background: rgba(22, 163, 74, 0.2);\n}\n.acr__inline-no {\n  background: rgba(220, 38, 38, 0.08);\n  color: var(--admin-red);\n}\n.acr__inline-no:hover {\n  background: rgba(220, 38, 38, 0.15);\n}\n\n/* ── Icon button ── */\n.acr__icon-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.9rem;\n  height: 1.9rem;\n  border: none;\n  border-radius: 6px;\n  background: none;\n  cursor: pointer;\n  font-size: 0.9rem;\n  color: var(--admin-muted);\n  transition:\n    background 0.12s,\n    color 0.12s;\n  flex-shrink: 0;\n}\n.acr__icon-btn:hover {\n  background: var(--admin-border);\n  color: var(--admin-text);\n}\n.acr__icon-btn:disabled {\n  opacity: 0.3;\n  cursor: default;\n}\n.acr__icon-btn--danger:hover {\n  background: rgba(220, 38, 38, 0.1);\n  color: var(--admin-red);\n}\n\n/* ════════════════════════════════════════════════════════\n   COURSE EDITOR\n════════════════════════════════════════════════════════ */\n.acr__editor {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 1.25rem;\n  min-height: 60vh;\n}\n.acr__editor--with-panel {\n  grid-template-columns: 1fr 0.8fr;\n  align-items: start;\n}\n\n.acr__editor-main {\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n}\n\n/* Editor header */\n.acr__editor-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n}\n.acr__back-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 0.82rem;\n  font-weight: 700;\n  color: var(--admin-muted);\n  padding: 0;\n  transition: color 0.15s;\n}\n.acr__back-btn:hover {\n  color: var(--admin-rust);\n}\n.acr__editor-head-right {\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n}\n.acr__settings-btn {\n  gap: 0.4rem !important;\n}\n\n/* Course title in editor */\n.acr__editor-title-wrap {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  background: #fff;\n  border: 1px solid var(--admin-border);\n  border-radius: 10px;\n  padding: 1rem 1.25rem;\n}\n.acr__editor-title-icon {\n  font-size: 1.4rem;\n  color: var(--admin-rust);\n  flex-shrink: 0;\n}\n.acr__course-title-editable {\n  font-size: 1.2rem;\n  font-weight: 700;\n}\n.acr__chapter-title-editable {\n  font-size: 0.92rem;\n  font-weight: 600;\n  flex: 1;\n  min-width: 0;\n}\n\n/* Stats under title */\n.acr__editor-stats {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.78rem;\n  color: var(--admin-muted);\n  padding: 0 0.25rem;\n}\n\n/* Settings panel */\n.acr__settings-panel {\n  padding: 1.25rem;\n}\n.acr__settings-title {\n  font-size: 0.88rem;\n  font-weight: 700;\n  color: var(--admin-text);\n  margin: 0 0 1rem;\n}\n.acr__settings-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 0.85rem;\n}\n.acr__settings-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0.85rem;\n}\n.acr__settings-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.5rem;\n  margin-top: 1rem;\n}\n\n/* ── Chapters ── */\n.acr__chapters {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n.acr__empty-chapters {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 3rem 1rem;\n  text-align: center;\n  background: #fff;\n  border: 2px dashed var(--admin-border);\n  border-radius: 10px;\n}\n\n/* Chapter row */\n.acr__chapter {\n  background: #fff;\n  border: 1px solid var(--admin-border);\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.acr__chapter-head {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  padding: 0.85rem 1rem;\n  border-bottom: 1px solid transparent;\n  background: var(--admin-surface);\n  transition: border-color 0.15s;\n}\n.acr__chapter:has(.acr__lessons) .acr__chapter-head {\n  border-bottom-color: var(--admin-border);\n}\n\n.acr__chapter-toggle {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 0.85rem;\n  color: var(--admin-muted);\n  flex-shrink: 0;\n  width: 1.5rem;\n  height: 1.5rem;\n  border-radius: 4px;\n  padding: 0;\n  transition: background 0.12s;\n}\n.acr__chapter-toggle:hover {\n  background: var(--admin-border);\n}\n\n.acr__chapter-num {\n  font-size: 0.65rem;\n  font-weight: 800;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--admin-rust);\n  flex-shrink: 0;\n  min-width: 2.5rem;\n}\n\n.acr__chapter-actions {\n  display: flex;\n  align-items: center;\n  gap: 0.2rem;\n  margin-left: auto;\n  flex-shrink: 0;\n}\n.acr__chapter-count {\n  font-size: 0.72rem;\n  color: var(--admin-muted);\n  margin-right: 0.35rem;\n  white-space: nowrap;\n}\n\n/* Lessons inside a chapter */\n.acr__lessons {\n  display: flex;\n  flex-direction: column;\n}\n.acr__lessons-empty {\n  font-size: 0.78rem;\n  color: var(--admin-muted);\n  padding: 1rem;\n  text-align: center;\n}\n\n.acr__lesson-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.65rem 1rem;\n  border-bottom: 1px solid var(--admin-border);\n  cursor: pointer;\n  transition: background 0.12s;\n}\n.acr__lesson-row:last-of-type {\n  border-bottom: none;\n}\n.acr__lesson-row:hover {\n  background: var(--admin-bg);\n}\n.acr__lesson-row--active {\n  background: rgba(var(--admin-rust-rgb), 0.04);\n  border-left: 2px solid var(--admin-rust);\n}\n\n.acr__lesson-left {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.84rem;\n  color: var(--admin-text);\n  min-width: 0;\n  flex: 1;\n}\n.acr__lesson-num {\n  font-size: 0.65rem;\n  font-weight: 800;\n  color: var(--admin-muted);\n  min-width: 1.2rem;\n}\n.acr__lesson-title {\n  font-weight: 500;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.acr__lesson-opt {\n  font-size: 0.65rem;\n  background: rgba(107, 98, 88, 0.1);\n  color: var(--admin-muted);\n  padding: 0.1rem 0.45rem;\n  border-radius: 99px;\n  flex-shrink: 0;\n}\n.acr__lesson-dur {\n  font-size: 0.68rem;\n  color: var(--admin-muted);\n  flex-shrink: 0;\n}\n.acr__lesson-actions {\n  display: flex;\n  align-items: center;\n  gap: 0.15rem;\n  flex-shrink: 0;\n}\n\n/* Add lesson form */\n.acr__add-lesson-form {\n  padding: 0.85rem 1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.6rem;\n  background: var(--admin-bg);\n  border-top: 1px solid var(--admin-border);\n}\n.acr__add-lesson-types {\n  display: flex;\n  gap: 0.4rem;\n  flex-wrap: wrap;\n}\n.acr__add-type-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n  padding: 0.3rem 0.65rem;\n  border-radius: 6px;\n  font-size: 0.74rem;\n  font-weight: 600;\n  border: 1.5px solid var(--admin-border);\n  background: #fff;\n  color: var(--admin-muted);\n  cursor: pointer;\n  transition: all 0.12s;\n}\n.acr__add-type-btn:hover {\n  border-color: var(--admin-rust);\n  color: var(--admin-rust);\n}\n.acr__add-type-btn--active {\n  background: var(--admin-rust);\n  border-color: var(--admin-rust);\n  color: #fff;\n}\n.acr__add-lesson-row {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.acr__add-lesson-btn,\n.acr__add-chapter-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.4rem;\n  width: 100%;\n  padding: 0.7rem;\n  background: none;\n  border: 2px dashed var(--admin-border);\n  border-radius: 0 0 9px 9px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: var(--admin-muted);\n  cursor: pointer;\n  transition: all 0.15s;\n}\n.acr__add-lesson-btn:hover,\n.acr__add-chapter-btn:hover {\n  border-color: var(--admin-rust);\n  color: var(--admin-rust);\n  background: rgba(var(--admin-rust-rgb), 0.03);\n}\n\n.acr__add-chapter-btn {\n  border-radius: 10px;\n  margin-top: 0;\n  padding: 1rem;\n}\n\n/* Add chapter form */\n.acr__add-chapter-form {\n  display: flex;\n  gap: 0.65rem;\n  align-items: center;\n  padding: 0.85rem 1rem;\n  background: #fff;\n  border: 1px solid var(--admin-border);\n  border-radius: 10px;\n}\n\n/* ════════════════════════════════════════════════════════\n   LESSON EDITOR PANEL\n════════════════════════════════════════════════════════ */\n.acr__lesson-editor {\n  background: #fff;\n  border: 1px solid var(--admin-border);\n  border-radius: 10px;\n  overflow: hidden;\n  position: sticky;\n  top: calc(var(--admin-topbar-h) + 1rem);\n  display: flex;\n  flex-direction: column;\n  max-height: calc(100vh - var(--admin-topbar-h) - 3rem);\n}\n\n.acr__le-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.9rem 1.1rem;\n  border-bottom: 1px solid var(--admin-border);\n  background: var(--admin-surface);\n  flex-shrink: 0;\n}\n.acr__le-head-left {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n.acr__le-title {\n  font-size: 0.88rem;\n  font-weight: 700;\n  color: var(--admin-text);\n}\n\n.acr__le-body {\n  padding: 1.1rem;\n  overflow-y: auto;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.acr__le-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.5rem;\n  padding: 0.85rem 1.1rem;\n  border-top: 1px solid var(--admin-border);\n  background: var(--admin-surface);\n  flex-shrink: 0;\n}\n\n/* Type grid in lesson editor */\n.acr__type-grid {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 0.4rem;\n}\n.acr__type-btn {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.25rem;\n  padding: 0.5rem 0.25rem;\n  border-radius: 7px;\n  border: 1.5px solid var(--admin-border);\n  background: #fff;\n  font-size: 0.68rem;\n  font-weight: 600;\n  color: var(--admin-muted);\n  cursor: pointer;\n  transition: all 0.12s;\n  text-align: center;\n}\n.acr__type-icon {\n  font-size: 1.1rem;\n}\n.acr__type-btn:hover {\n  border-color: var(--admin-rust);\n  color: var(--admin-rust);\n}\n.acr__type-btn--active {\n  background: var(--admin-rust);\n  border-color: var(--admin-rust);\n  color: #fff;\n}\n\n/* ══ Responsive ═══════════════════════════════════════════ */\n@media (max-width: 1199px) {\n  .acr__editor--with-panel {\n    grid-template-columns: 1fr;\n  }\n  .acr__lesson-editor {\n    position: static;\n    max-height: none;\n  }\n  .acr__type-grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n@media (max-width: 767px) {\n  .acr__stat-bar {\n    grid-template-columns: 1fr 1fr;\n  }\n  .acr__stat-bar > :last-child {\n    grid-column: 1 / -1;\n  }\n  .acr__course-card {\n    flex-direction: column;\n  }\n  .acr__course-actions {\n    width: 100%;\n    justify-content: flex-end;\n  }\n  .acr__settings-row {\n    grid-template-columns: 1fr;\n  }\n  .acr__type-grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n  .acr__add-lesson-row {\n    flex-wrap: wrap;\n  }\n  .acr__chapter-head {\n    flex-wrap: wrap;\n  }\n}\n\n/* ── Lesson editor loading state ── */\n.acr__le-loading {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  padding: 0.6rem 0;\n  font-size: 0.78rem;\n  color: var(--admin-muted);\n}\n\n/* ═══════════════════════════════════════════════════════════\n   QUIZ BUILDER\n═══════════════════════════════════════════════════════════ */\n.acr__quiz-builder {\n  display: flex;\n  flex-direction: column;\n  gap: 0.85rem;\n}\n\n/* ── Question card ── */\n.acr__quiz-question {\n  border: 1px solid var(--admin-border);\n  border-radius: 9px;\n  overflow: hidden;\n  background: #fff;\n}\n\n.acr__quiz-q-head {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  padding: 0.65rem 0.85rem;\n  background: var(--admin-surface);\n  border-bottom: 1px solid var(--admin-border);\n  flex-wrap: wrap;\n}\n\n.acr__quiz-q-num {\n  font-size: 0.68rem;\n  font-weight: 800;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--admin-rust);\n  flex-shrink: 0;\n  min-width: 1.8rem;\n}\n\n/* Multiple / Text toggle */\n.acr__quiz-type-toggle {\n  display: flex;\n  border: 1.5px solid var(--admin-border);\n  border-radius: 6px;\n  overflow: hidden;\n  flex-shrink: 0;\n}\n.acr__quiz-type-btn {\n  padding: 0.28rem 0.65rem;\n  font-size: 0.72rem;\n  font-weight: 600;\n  background: #fff;\n  border: none;\n  cursor: pointer;\n  color: var(--admin-muted);\n  transition: all 0.13s;\n  border-right: 1.5px solid var(--admin-border);\n}\n.acr__quiz-type-btn:last-child {\n  border-right: none;\n}\n.acr__quiz-type-btn:hover {\n  background: var(--admin-bg);\n}\n.acr__quiz-type-btn--active {\n  background: var(--admin-rust);\n  color: #fff;\n}\n\n.acr__quiz-remove-q {\n  margin-left: auto;\n}\n\n/* Question text input */\n.acr__quiz-q-input {\n  margin: 0.65rem 0.85rem 0.5rem;\n  width: calc(100% - 1.7rem);\n  font-weight: 600;\n  font-size: 0.88rem;\n}\n\n/* ── Options (multiple choice) ── */\n.acr__quiz-options {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n  padding: 0.35rem 0.85rem 0.75rem;\n}\n\n.acr__quiz-option {\n  display: flex;\n  align-items: center;\n  gap: 0.45rem;\n}\n\n/* Correct answer circle button */\n.acr__quiz-correct-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.7rem;\n  height: 1.7rem;\n  border: none;\n  border-radius: 50%;\n  background: none;\n  cursor: pointer;\n  font-size: 1.05rem;\n  color: var(--admin-muted);\n  flex-shrink: 0;\n  transition: color 0.12s;\n  padding: 0;\n}\n.acr__quiz-correct-btn:hover {\n  color: var(--admin-rust);\n}\n.acr__quiz-correct-btn--on {\n  color: var(--admin-green);\n}\n\n/* Empty circle (since HiOutlineCircle doesn't exist in hi2) */\n.acr__quiz-circle {\n  display: inline-block;\n  width: 1.1rem;\n  height: 1.1rem;\n  border: 2px solid currentColor;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.acr__quiz-opt-letter {\n  font-size: 0.7rem;\n  font-weight: 800;\n  color: var(--admin-muted);\n  min-width: 1rem;\n  text-align: center;\n  flex-shrink: 0;\n}\n\n.acr__quiz-opt-input {\n  flex: 1;\n  font-size: 0.84rem;\n  padding: 0.45rem 0.7rem;\n  min-width: 0;\n}\n\n.acr__quiz-add-opt {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n  margin-top: 0.2rem;\n  padding: 0.3rem 0.6rem;\n  background: none;\n  border: 1.5px dashed var(--admin-border);\n  border-radius: 6px;\n  font-size: 0.74rem;\n  font-weight: 600;\n  color: var(--admin-muted);\n  cursor: pointer;\n  transition: all 0.13s;\n  align-self: flex-start;\n}\n.acr__quiz-add-opt:hover {\n  border-color: var(--admin-rust);\n  color: var(--admin-rust);\n}\n\n.acr__quiz-hint {\n  font-size: 0.71rem;\n  color: var(--admin-amber);\n  margin: 0.2rem 0 0;\n  font-weight: 500;\n}\n\n/* ── Text answer hint ── */\n.acr__quiz-text-hint {\n  display: flex;\n  align-items: center;\n  gap: 0.45rem;\n  margin: 0.35rem 0.85rem 0.75rem;\n  font-size: 0.77rem;\n  color: var(--admin-muted);\n  background: var(--admin-bg);\n  border-radius: 6px;\n  padding: 0.5rem 0.7rem;\n}\n\n/* ── Add question button ── */\n.acr__quiz-add-q {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.4rem;\n  width: 100%;\n  padding: 0.75rem;\n  background: none;\n  border: 2px dashed var(--admin-border);\n  border-radius: 9px;\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: var(--admin-muted);\n  cursor: pointer;\n  transition: all 0.15s;\n}\n.acr__quiz-add-q:hover {\n  border-color: var(--admin-rust);\n  color: var(--admin-rust);\n  background: rgba(var(--admin-rust-rgb), 0.03);\n}\n\n/* ── Tag multi-select grid ── */\n.acr__tag-grid { display:flex; flex-wrap:wrap; gap:0.4rem; }\n.acr__tag-btn {\n  padding:0.3rem 0.75rem; border-radius:99px;\n  border:1.5px solid var(--admin-border); background:#fff;\n  font-size:0.74rem; font-weight:600; color:var(--admin-muted);\n  cursor:pointer; transition:all 0.13s;\n}\n.acr__tag-btn:hover { border-color:var(--admin-rust); color:var(--admin-rust); }\n.acr__tag-btn--active { background:var(--admin-rust); border-color:var(--admin-rust); color:#fff; }\n.acr__tag-btn--stage.acr__tag-btn--active { background:#1e2a1e; border-color:#1e2a1e; }\n\n/* Who gets it (shared course library) */\n.acr__rules { margin-bottom: 1rem; }\n.acr__share { display: flex; gap: 0.6rem; align-items: flex-start; margin-top: 0.25rem; cursor: pointer; }\n.acr__share input { margin-top: 0.2rem; accent-color: var(--admin-rust); width: 1rem; height: 1rem; }\n.acr__share b { display: block; font-size: 0.84rem; color: var(--admin-text); }\n.acr__share em { display: block; font-style: normal; font-size: 0.78rem; color: var(--admin-muted); line-height: 1.45; max-width: 60ch; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
